import Vue, { h } from 'vue'
import Router from 'vue-router'
import { staticRoutes } from './staticRoutes'
Vue.use(Router)

/* Layout */
const  Layout  = () => import('@/views/layout/Layout.vue')
// import Layout from '@/views/layout/Layout.vue'

/**
 * hidden: true                   if `hidden:true` will not show in the sidebar(default is false)
 * alwaysShow: true               if set true, will always show the root menu, whatever its child routes length
 *                                if not set alwaysShow, only more than one route under the children
 *                                it will becomes nested mode, otherwise not show the root menu
 * redirect: noredirect           if `redirect:noredirect` will no redirct in the breadcrumb
 * name:'router-name'             the name is used by <keep-alive> (must set!!!)
 * meta : {
    title: 'title'               the name show in submenu and breadcrumb (recommend set)
    icon: 'svg-name'             the icon show in the sidebar,
  }
 **/
export const constantRouterMap = [
  {path: '/login', component: () => import('@/views/login/index'), hidden: true},
  {path: '/404', component: () => import('@/views/404'), hidden: true},
  {
    path:"/",
    redirect:"/home/home",
    component: () => import('@/views/home/index'),
  },
  {
    path:"/home",
    redirect:"/home/home",
    component: () => import('@/views/home/index'),
  },
  {
    path: '/home',
    component: Layout,
    meta: {title: '首页', icon: 'home'},
    children: [{
      path: 'home',
      name: 'home',
      component: () => import('@/views/home/index'),
      meta: {title: '数据总览', icon: 'home'}
    },
    // {
    //   name: 'document',
    //   path: 'https://www.macrozheng.com',
    //   meta: {title: '学习教程', icon: 'document'}
    // },
    // {
    //   name: 'video',
    //   path: 'https://www.macrozheng.com/mall/catalog/mall_video.html',
    //   meta: {title: '视频教程', icon: 'video'}
    // },
    {
      path: 'user',
      name: 'user',
      component: () => import('@/views/home/myuser'),
      meta: {title: '个人中心', icon: 'dashboard'},
      hidden: true
    },
    ]
  },
  
]

export default new Router({
  mode: 'history',
  base: '/',
  scrollBehavior: () => ({y: 0}),
  routes: constantRouterMap
})




// WEBPACK FOOTER //
// ./src/router/index.js